import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {deleteResource} from 'src/openapi/admin/apis/EntitlementsResourceApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    resourceId: string,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useRemoveResource = ({resourceId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((reason: string) => apiDispatch(
        deleteResource({resourceId, deleteResourceRequest: {reason}}),
    ), [resourceId, apiDispatch]);

    return useCommonEventHook({
        eventAction,
        onSuccess,
        onFail,
    });
};
